//  ####    #####   ####  ######  #####     #####   ##    ##
//  ##  ##  ##     ##       ##    ##  ##   ##   ##   ##  ##
//  ##  ##  #####   ###     ##    #####    ##   ##    ####
//  ##  ##  ##        ##    ##    ##  ##   ##   ##     ##
//  ####    #####  ####     ##    ##   ##   #####      ##
/*
data属性に対応するクラスのDOMを削除する
<button type="button" class="js-destroy" data-destroy="hoge">
    削除
</button>
<div class="js-destroy--hoge">これが消える</div>
*/

window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-destroy')) {
    return
  }
  const target = e.target.dataset.destroy
  const destroyList = document.getElementsByClassName('js-destroy--' + target)

  for (const iterator of destroyList) {
    iterator.parentNode.removeChild(iterator)
  }
})
